import { StyleSheet } from "@react-pdf/renderer";
const Contact = () => {
    console.log("Contact Page Loaded");
     const styles = StyleSheet.create({
       page: {
        flexDirection: "row",
        backgroundColor: "#61dafb",
      }
     });    
return (
        <div style={styles.page} className="col-sm-4">
            <h3>Internet Software Works</h3>
            <h4>Let us help you with your project</h4>

            <p>
                P.O. Box 2448<br />
                Silverthorne, CO 80498<br />
            </p>

            <p><i className="fa fa-phone"></i> <abbr title="Phone">P</abbr>: (970) 393-0470</p>

            <p><i className="fa fa-envelope-o"></i> <abbr title="Email">E</abbr>: <a
                    href="mailto:tome@internetsoftwareworks.com">tome@internetsoftwareworks.com</a></p>

            <p><i className="fa fa-clock-o"></i> <abbr title="Hours">H</abbr>: Monday - Friday: 9:00 AM to 5:00 PM</p>
    
        </div>  
);
};

export default Contact;
